<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img src="../../assets/image/RUS.png" alt="">
                </div>
                <div class="main-area" :class="{line:!backdrop}">
                    <div class="title-wrap">
                        <div class="title">
                            <span class="zh">
                                国内集货试题
                            </span>
                                <span class="en">
                                Domestic collection test questions
                            </span>
                        </div>
                        <div class="backdrop-wrap">
                            <span :class="{active:backdrop}" @click="backdrop=!backdrop">
                                集货背景
                            </span>
                            <span :class="{active:!backdrop}" @click="backdrop=!backdrop">
                                试题
                            </span>
                        </div>
                    </div>
                    <div class="main-area-box backdrop" v-show="backdrop">
                        <div class="item" style="width: 100%;height: 100%">
                            <div class="tit">
                                {{questions.premise}}
                            </div>
                            <div class="answer">
                                <img :src="item" alt="" v-for="(item,index) in questions.image">
                            </div>
                        </div>
                    </div>
                    <div class="main-area-box" v-show="!backdrop">
                        <div class="item" :class=" item.answer === '' ?'' : (item.answer === item.value ? 'correct':'mistake') " v-for="(item,index) in questions.question" :key="index">
                            <div class="tit">
                                {{item.title}}
                            </div>
                            <div class="answer">
                                <div class="answer-item" v-for="(itemm,indexx) in item.items" :key="indexx" :class=" item.answer === '' ?'' : (item.value === indexx ? 'correct':'mistake') ">
                                    <span @click="item.answer=indexx">
                                        {{itemm}}
                                    </span>
                                </div>
                            </div>
                            <div class="answer-reason">
                                解释：{{item.note}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.prev"  @click="$router.push($route.meta.prev)">
                    上一步
                </span>
                <span class="btn" v-if="$route.meta.next" @click="$router.push($route.meta.next)">
                    下一步
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                list: [
                    'ASpace.png',
                    'BSpace.png'
                ],
                count:'',
                questions:{},
                backdrop:true
            }
        },
        created() {
            this.getList()
        },
        methods:{
            getList(){
                this.axios.post(`/resource/question/${this.$store.state.record.country}.json`).then(res=>{
                    if(res.login && res.succeed){
                        res.storeGoods.question.forEach(item=>{
                            item.answer = ""
                        })
                        this.questions = res.storeGoods;
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;min-width:364px;
                flex-shrink: 0;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                padding: 30px 60px;
                position: relative;

                &.line:before {
                    content: '';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 80%;
                    background: #2c3e50;
                }

                div.title-wrap {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    div.title {
                        color: #004bff;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;

                        span.zh {
                            font-size: 22px;
                            font-weight: bolder;
                        }
                        span.en {
                            font-size: 12px;
                        }
                    }
                    div.backdrop-wrap {
                        width: 200px;
                        padding-bottom: 14px;
                        color: #9e9e9e;
                        font-size: 22px;
                        font-weight: bolder;
                        span {
                            cursor: pointer;
                        }
                        span.active {
                            color: #004bff;
                        }
                    }
                }

                .main-area-box {
                    display: flex;
                    flex-wrap: wrap;
                    height: 100%;
                    padding: 10px 0;

                    &.backdrop {
                        .item {
                            div.tit {
                                font-size: 18px;
                                font-weight: 600;
                                color: #6b6b6b;
                                text-indent: 38px;
                                line-height: 28px;
                            }
                            div.answer {
                                display: flex;
                                justify-content: space-evenly;
                            }
                        }
                    }

                    div.item {
                        width: 50%;
                        height: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: flex-start;
                        padding-right: 30px;

                        &.correct {
                            .answer:before {

                            }
                            .answer-item.correct > span {
                                color: #42b983;
                            }
                            .answer-item.mistake > span {
                                color: red;
                            }
                        }
                        &.mistake {
                            .answer-item.correct > span {
                                color: #42b983;
                            }
                            .answer-item.mistake > span {
                                color: red;
                            }
                        }

                        &:nth-child(2n){
                            padding-right: 0;
                            padding-left: 30px;
                        }
                        div.tit {
                            text-align: left;
                            margin-bottom: 30px;
                            font-size: 18px;
                            font-weight: 600;
                            color: #4e4e4e;
                        }
                        .answer {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            width: 100%;
                            padding: 0 30px;
                            margin-bottom: 20px;

                            i.icon-wrong {
                                color: red;
                            }
                            i.icon-zhengque {
                                color: #42b983;
                            }

                            div.answer-item {
                                font-size: 18px;
                                font-weight: bolder;
                                color: #7f7f7f;
                                display: flex;
                                flex-wrap: wrap;
                                flex-direction: column;
                                justify-content: flex-start;
                                margin-right: 40px;
                                cursor: pointer;
                                img {
                                    margin-bottom: 10px;
                                }
                            }
                        }
                        .answer-reason {
                            width: 100%;
                            word-break: break-all;
                            text-align: left;
                            color: #42b993;
                            font-size: 17px;
                            font-weight: 600;
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
